export enum DealStrategyEnum {
  MIXED = 'Mixed',
  CORE = 'Core',
  CORE_PLUS = 'CorePlus',
  VALUE_ADD = 'ValueAdd',
  OPPORTUNISTIC = 'Opportunistic',
  DEVELOPMENT = 'Development',
}
